import React from "react";

const MappingServices = () => {
  const services = [
    "Deep Freezer", "Room Mapping", "Bacteriological Incubator", "Water Bath",
    "Hot Air Oven", "Dry Heat Sterilizer", "Bulk Storage Area", "Clean Equipment Room",
    "IPQC", "Laboratory Oven", "AC Instrument Room", "Oven", "Incubator Area",
    "Dispensing Area", "Culture Handling Area", "Expansion Area", "RM Store",
    "Cooling Cabinet", "Sampling & Dispensing Area", "Bottle Cooler", "Air Lock",
    "Packing Hall", "Finished Goods Store Area", "Warehouse Room", "B.O.D Incubator",
    "Refrigerator", "Room Mapping", "Water Bath", "Cooling Incubator", "Drying Oven",
    "Cold Store", "Vacuum Oven", "Stability Chamber", "Walk–In-Humidity Chamber",
    "Vacuum Tray Dryer", "Autoclave (Empty, Minimum Load, Maximum Load)",
    "Cool Van Transportation", "HVAC Validation", "On-site Service",
  ];

  const images = ["map1.jpeg", "map2.jpeg","map7.jpeg","map4.jpeg","map6.jpeg","map3.jpeg"];

  return (
    <section className="bg-gray-100 py-16 px-6">
      <div className="max-w-7xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-bold border-b-4 inline-block border-orange-500 pb-2">
          Temperature & Humidity Mapping Services
        </h2>
        <div className="bg-white flex flex-col lg:flex-row gap-10 items-start my-10 p-2">
          <div className="w-full lg:w-2/3  text-gray-800 shadow-lg rounded-xl p-6 md:p-8">
            <div className="grid gap-4 grid-cols-1 sm:grid-cols-2 md:grid-cols-3">
              {services.map((service, idx) => (
                <div
                  key={idx}
                  className="flex items-center text-left font-bold border border-orange-200 rounded-lg px-4 py-2 text-sm hover:bg-orange-100 transition shadow-sm"
                >
                  {service}
                </div>
              ))}
            </div>
          </div>

          {/* Right: Images */}
         <div className="md:w-1/2 grid grid-cols-2 gap-6 mt-10">
            {images.map((img, index) => (
              <img
                key={index}
                src={`./img/service/${img}`}
                alt={`Mapping visual ${index + 1}`}
                className="w-full h-40 rounded-lg shadow-lg object-cover hover:scale-105 transform transition duration-300 "
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default MappingServices;
